import { createUseStyles } from 'react-jss';

import { MD_MEDIA_QUERY } from '~shared/media-query';
import { PricingAppTheme } from '~app/styles/pricing/types';

export default createUseStyles(({ spacing, type }: PricingAppTheme) => ({
  Heading: {
    '& h1': {
      display: 'block',
      fontSize: type.fontSize.sectionTitle,
      textAlign: 'center',
      margin: [spacing[5], spacing[3], spacing[2]],
      fontWeight: type.fontWeight.medium,
      [MD_MEDIA_QUERY]: {
        fontSize: type.fontSize.hero2,
        margin: [spacing[6], 'auto', spacing[2]],
      },
    },
  },
}));
